// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.support.RentalManagerUserSupportWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetHelpTopicListResponseV2Dto,
  RentalManagerSupportHelpArticlesResponseDto,
  RentalManagerSupportHelpCategory,
  RentalManagerSupportHelpTopic,
  RentalManagerUserSupportRequestV1Dto,
} from '../..';

interface GetHelpArticlesParams {
  category?: RentalManagerSupportHelpCategory;
  topic?: RentalManagerSupportHelpTopic;
}

export const RentalManagerUserSupportWebApiHandler_getHelpArticles_Path = '/api/web/v1/users/support/getHelpArticles';

/**
 * Get help articles
 */
export const RentalManagerUserSupportWebApiHandler_getHelpArticles = (
  getParams: GetHelpArticlesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetHelpArticlesParams, never, RentalManagerSupportHelpArticlesResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserSupportWebApiHandler_getHelpArticles_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserSupportWebApiHandler_getHelpTopics_Path = '/api/web/v1/users/support/getHelpTopics';

/**
 * Get help topics with categories and outages
 */
export const RentalManagerUserSupportWebApiHandler_getHelpTopics = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetHelpTopicListResponseV2Dto>(
    {
      endpoint: RentalManagerUserSupportWebApiHandler_getHelpTopics_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserSupportWebApiHandler_submitRequest_Path = '/api/web/v1/users/support/submitRequest';

/**
 * Submit a support request
 */
export const RentalManagerUserSupportWebApiHandler_submitRequest = (
  postData: RentalManagerUserSupportRequestV1Dto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerUserSupportRequestV1Dto, string>(
    {
      endpoint: RentalManagerUserSupportWebApiHandler_submitRequest_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
